import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { white, universalStyles } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  heading: {
    marginTop: 24,
  },
  text: {
    color: white,
  },
}));

const AcquisitionPage04 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h6" className={classes.heading}>
        Purpose
      </Typography>
      <Typography className={classes.text}>
        Explore considerations to be applied at each step of the image acquisition process for obtaining the best
        quality images with POSLUMA
      </Typography>
      <Typography variant="h6" className={classes.heading}>
        Objectives
      </Typography>
      <ul className={classNames(classes.poslumaList, classes.text)}>
        <li>Identify recommended steps to effectively capture optimal quality images</li>
        <li>
          Define key recommendations for dosing, administration, patient preparation, image acquisition, and image
          reconstruction
        </li>
      </ul>
      <Typography variant="h6" className={classes.heading}>
        Explore each step to learn more about image acquisition
      </Typography>
      <ul className={classNames(classes.poslumaList, classes.text)}>
        <li>Proceed to the next page to view the 5 steps</li>
      </ul>
    </>
  );
};

export default AcquisitionPage04;
